import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS } from "../../../../constants/Define";
import TourTicketList from './TourTicketList';

let permisionActions = [];
class TourTickets extends Component {

    state = {
        filters: {
            pageSize: this.props.tourTicketsState.pageSize,
            pageIndex: this.props.tourTicketsState.pageIndex,
        }
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKETS);
        this.props.onListTourTicket(this.state.filters);
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, tourTickets } = this.props.tourTicketsState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tourTickets'}
                        titleHeader={t('navigation.tourTickets')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={`/tourtickets/action`}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <TourTicketList loading={isFetching}
                                  permisions={permisionActions}
                                  tourTickets={tourTickets}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteTourTicket}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    

    onChangeLanguage = () => {
        this.props.onListTourTicket(this.state.filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListTourTicket(newFilters);
    };

    onDeleteTourTicket = (item) => {
        this.props.onDeleteTourTicket(item, {
            filters: {
                pageSize: this.props.tourTicketsState.pageSize,
                pageIndex: this.props.tourTicketsState.pageIndex
            }
        });
    }
}


export default TourTickets;
